import { promoConstants } from "../constants/promoConstants";

const initialState = {
  sending: false,
  promoResponse: {},
  promoList: {},
  deletedPromo: {},
  promoDetail: {},
  updatedPromo: {},
  error: {},
  failuremessage: ""
};

export default function promoReducer(state = initialState, action) {
  switch (action.type) {
    case promoConstants.ADD_PROMO_REQUEST:
      return {
        sending: true
      };
    case promoConstants.ADD_PROMO_SUCCESS:
      return {
        ...state,
        promoResponse: action.data
      };
    case promoConstants.ADD_PROMO_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case promoConstants.GET_PROMO_REQUEST:
      return {
        sending: true
      };
    case promoConstants.GET_PROMO_SUCCESS:
      return {
        ...state,
        promoList: action.data
      };
    case promoConstants.GET_PROMO_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case promoConstants.DELETE_PROMO_REQUEST:
      return {
        sending: true
      };
    case promoConstants.DELETE_PROMO_SUCCESS:
      return {
        ...state,
        deletedPromo: action.data
      };
    case promoConstants.DELETE_PROMO_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case promoConstants.GET_PROMODETAIL_REQUEST:
      return {
        sending: true
      };
    case promoConstants.GET_PROMODETAIL_SUCCESS:
      return {
        ...state,
        promoDetail: action.data.data
      };
    case promoConstants.GET_PROMODETAIL_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case promoConstants.UPDATE_PROMO_REQUEST:
      return {
        sending: true
      };
    case promoConstants.UPDATE_PROMO_SUCCESS:
      return {
        ...state,
        updatedPromo: action.data
      };
    case promoConstants.UPDATE_PROMO_FAILURE:
      return {
        ...state,
        error: action.error
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/promoReducer.js